var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForumDetailsUsericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.039,
    height: 13.039,
    viewBox: "0 0 13.039 13.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M6.52,7.334A3.667,3.667,0,1,0,2.852,3.667,3.668,3.668,0,0,0,6.52,7.334Zm3.26.815h-1.4a4.433,4.433,0,0,1-3.713,0H3.26A3.26,3.26,0,0,0,0,11.409v.407a1.223,1.223,0,0,0,1.222,1.222H11.817a1.223,1.223,0,0,0,1.222-1.222v-.407A3.26,3.26,0,0,0,9.779,8.149Z",
    fill: "#a7a7a7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumDetailsUsericon);
export default __webpack_public_path__ + "static/media/forum-details-usericon.d9e57ea64d798c4097b6c9827217c55f.svg";
export { ForwardRef as ReactComponent };